import React, { useState } from 'react';

import { Grid, Link as MuiLink, Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Translate } from 'react-localize-redux';

import { gdpr } from '../../../helpers/gdpr';
import CookieModal from '../../CookiePreferences/CookieModal';

const useStyles = makeStyles((theme: Theme) => ({
  cookiePreferences: {
    lineHeight: '20px',
    cursor: 'pointer',
  },
  cookiesLogin: {
    lineHeight: '20px',
  },
}));

const CookiePreferences: React.FC<{}> = () => {
  const classes = useStyles();
  const [isOpenManageCookiesModal, setIsOpenManageCookiesModal] = useState<boolean>(false);

  const isGDPREnabled = gdpr.isGDPREnabled();
  if (isGDPREnabled !== 'true') {
    return null;
  }

  const handleCookiePreferencesClick = () => {
    setIsOpenManageCookiesModal(true);
  };
  const handleDone = () => {
    setIsOpenManageCookiesModal(false);
  };

  return (
    <>
      <Grid container item>
        <Typography className={classes.cookiesLogin} variant="caption">
          <Translate id="Cookies_Login" />
        </Typography>
        <MuiLink
          className={classes.cookiePreferences}
          data-fd="cookie-preferences"
          onClick={handleCookiePreferencesClick}
          role="link"
          variant="caption"
        >
          <Translate id="Cookie_settings" />
        </MuiLink>
      </Grid>
      <CookieModal isOpenModal={isOpenManageCookiesModal} handleDone={handleDone} />
    </>
  );
};

export default CookiePreferences;
